export const proxy_ko = {
  'reset-password-modal': {
    title: '비밀번호 재설정',
    description: '계정 비밀번호가 만료되었습니다.\n비밀번호를 재설정하려면 아래 양식을 작성하세요.',
    form: {
      fields: {
        currentPassword: {
          name: '현재 비밀번호',
          label: '현재 비밀번호',
          placeholder: '현재 비밀번호를 입력하세요',
        },
        newPassword: {
          name: '새 비밀번호',
          label: '새 비밀번호',
          placeholder: '새 비밀번호를 입력하세요',
        },
        newPasswordConfirm: {
          name: '새 비밀번호 확인',
          label: '새 비밀번호 확인',
          placeholder: '새 비밀번호를 다시 입력하세요',
        },
      },
      'submit-button': '확인',
    },
  },
  errors: {
    'invalid-current-password': '현재 비밀번호가 올바르지 않습니다.',
    'not-match-new-password': '새 비밀번호가 일치하지 않습니다.',
    'already-used-password': '새 비밀번호는 현재 비밀번호와 같을 수 없습니다.',
    default: '비밀번호 재설정 요청이 유효하지 않습니다.\n처음부터 비밀번호를 재설정해 주세요.',
  },
};
